import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=94d46d5e&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=94d46d5e&scoped=true&lang=css&"
import style1 from "./Icon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d46d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d46d5e')) {
      api.createRecord('94d46d5e', component.options)
    } else {
      api.reload('94d46d5e', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=94d46d5e&scoped=true&", function () {
      api.rerender('94d46d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/Icon.vue"
export default component.exports